customElements.define("quick-add", class QuickAdd extends HTMLElement{
    // La configuración va en connectedCallback y no en el constructor: si una app (p. ej. Samita) clona o
    // recoloca la tarjeta, el constructor se ejecuta con el elemento fuera de la página y sin hijos, y fallaba
    // (sin contenedor para mouseleave ni botones de añadir). Se configura una sola vez.
    connectedCallback(){
        if (this.initialized) return
        this.initialized = true

        this.quickAddWrapper = this.querySelector('.quick-add')
        this.toggleQuickAddBtn = this.querySelector('.js-toggle-quick-add')
        this.atcBtns = this.querySelectorAll('.js-add-quick-add-variant')
        this.cardWrapper = this.closest('.grid-item-product-general')
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');


        //Close on exit grid item
        if(this.cardWrapper){
            this.cardWrapper.addEventListener("mouseleave", this.closeQuickAdd.bind(this))
        }

        //Open quick add on btn click if it exists
        if(this.toggleQuickAddBtn){
            this.toggleQuickAddBtn.addEventListener("click", this.showQuickAdd.bind(this))
          if(window.innerWidth>768){
            this.toggleQuickAddBtn.addEventListener("mouseenter", this.showQuickAdd.bind(this))
          }
        }

        //Add to cart that variant
        this.atcBtns.forEach(btn=>btn.addEventListener("click", this.addToCart.bind(this)))

        //Show quick add btns if on mobile (quick-add.liquid solo pinta el toggle en la rama elsif, que hoy no se alcanza)
        if(window.innerWidth<768 && this.toggleQuickAddBtn){
            this.toggleQuickAddBtn.classList.remove("hidden")
            document.addEventListener("click", (e)=>{
                if(!e.target.closest('quick-add')){
                    this.closeQuickAdd()
                }
            })
        }
    }

    showQuickAdd(){
        this.quickAddWrapper.classList.remove("hidden")
        this.toggleQuickAddBtn.classList.add("hidden")
    }

    closeQuickAdd(){
        if(this.quickAddWrapper && this.toggleQuickAddBtn){
            this.quickAddWrapper.classList.add("hidden")
            this.toggleQuickAddBtn.classList.remove("hidden")
        }
    }

    addToCart(e){
        const clickedBtn = e.target
        const variantId = clickedBtn.dataset.variantId
        console.log("Hola", variantId)

        const data = {
            items: [
                {
                    id: variantId,
                    quantity: 1
                }
            ]
        }

        fetch(window.Shopify.routes.root + 'cart/add.js?sections=cart-drawer,cart-icon-bubble', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        .then(response => {
            return response.json();
          })
        .then(response=>{
            this.cart.renderContents(response);
        })
        .catch((error) => {
        console.error('Error:', error);
        })
        .finally(() => {
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        });
    }
})